import './PriceOffers.scss';

import { useMemo } from 'react';

import { AtolyeTable, ContentWrapper, Footer, Header, PageTitle, PageWrapper, useUser } from '.';

import { columnsData } from './utils';
// import { Link } from 'react-router-dom';
import AtolyeDatePicker from 'components/AtolyeTable/components/AtolyeDatePicker';
import usePriceOffers from 'hooks/usePriceOffers';
// import ExportButton from './components/ExportButton';

const PriceOffers = (props) => {
  // Hooks
  const {
    loading,
    pageCount,
    priceOffers,
    filters,
    dateFilter,
    sorting,
    totalRowsCount,
    getPriceOffers,
    // exportAllPriceOffers,
    setFilters,
    setAreFiltersUpdated,
    setDateFilter,
    setSorting,
    setIsSortingUpdated,
  } = usePriceOffers();
  const { user, userPermissions } = useUser();

  // Declarations

  const columns = useMemo(() => columnsData, []);
  const data = useMemo(() => priceOffers, [priceOffers]);

  return (
    <>
      <Header user={user} {...props} />
      <ContentWrapper>
        <PageTitle title="Fiyat Teklifleri" />
        <PageWrapper>
          {!userPermissions?.includes(30) ? (
            <div className="alert alert-danger">
              <strong>Yetkiniz yok!</strong> Fiyat tekliflerini görüntülemek için yetkiniz
              bulunmamaktadır.
            </div>
          ) : (
            <>
              <div className="d-flex">
                <AtolyeDatePicker
                  isPriceOffersDateFilter
                  dateFilter={dateFilter}
                  setDateFilter={setDateFilter}
                />
                {/* {userRole !== 2 && <ExportButton loading={loading} onClick={() => exportAllOrders()} />} */}
              </div>
              <AtolyeTable
                columns={columns}
                data={data}
                fetchData={getPriceOffers}
                filters={filters}
                dateFilter={dateFilter}
                setFilters={setFilters}
                setAreFiltersUpdated={setAreFiltersUpdated}
                sorting={sorting}
                setSorting={setSorting}
                setIsSortingUpdated={setIsSortingUpdated}
                loading={loading}
                pageCount={pageCount}
                total={totalRowsCount}
              />
            </>
          )}
        </PageWrapper>
      </ContentWrapper>
      <Footer />
    </>
  );
};

export default PriceOffers;
